// extracted by mini-css-extract-plugin
export default {"List":"Customers_List__B3zIF","Link":"Customers_Link__SyhiM","Item":"Customers_Item__uqIfI","Logo":"Customers_Logo__jxpZi"};